module.exports = ".navigation {\n  z-index: 50; }\n\n.right-align {\n  text-align: right; }\n"